import { render, staticRenderFns } from "./BreadCrumbComponent.vue?vue&type=template&id=2c3ac55a&"
import script from "./BreadCrumbComponent.vue?vue&type=script&lang=ts&"
export * from "./BreadCrumbComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/src/services/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c3ac55a')) {
      api.createRecord('2c3ac55a', component.options)
    } else {
      api.reload('2c3ac55a', component.options)
    }
    module.hot.accept("./BreadCrumbComponent.vue?vue&type=template&id=2c3ac55a&", function () {
      api.rerender('2c3ac55a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/BreadCrumbComponent.vue"
export default component.exports